<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add v-if="hasPerm('machines.create')" @invoke-method="invokeMethod($event)" action="openMachineForm"></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetMachines(true)"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile>
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>
                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-switch
                                                v-model="filter.status"
                                                color="success"
                                                :label="filter.status == '1' ? $t('lang.active') : $t('lang.inactive')"
                                                true-value="1"
                                                false-value="0"
                                            ></v-switch>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="machines" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="openMachineForm(props.item)">
                                <td>{{ props.item.machine_id }}</td>
                                <td>{{ props.item.line_id }}</td>
                                <td>{{ props.item.machine_name }}</td>
                                <td>{{ props.item.short_code }}</td>
                                <td>{{ props.item.category_id }}</td>
                                <td>{{ props.item.status_id }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="machines"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="machine_dialog">
                <v-card>
                    <v-form ref="form_machine">
                        <v-card-title>
                            <span class="headline">{{ machine.machine_id ? $t("lang.edit_machine") : $t("lang.add_machine") }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeMachineDialog"
                                :dialog-status="machine_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-focus="machine_dialog"
                                            v-model="machine.line_id"
                                            :label="$t('lang.line_id')"
                                            :items="production_lines"
                                            item-value="line_id"
                                            item-text="production_line"
                                            :rules="ifValid('machines.line_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="machine.machine_name"
                                            :label="`${$t('lang.machine_name')} *`"
                                            :counter="showCounter(machine.machine_name, 'machines.machine_name')"
                                            :rules="ifValid('machines.machine_name')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="machine.short_code"
                                            :label="$t('lang.short_code')"
                                            :counter="showCounter(machine.short_code, 'machines.short_code')"
                                            :rules="ifValid('machines.short_code')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="machine.category_id"
                                            :label="$t('lang.category_id')"
                                            :counter="showCounter(machine.category_id, 'machines.category_id')"
                                            :rules="ifValid('machines.category_id')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="machine.status_id"
                                            :label="$t('lang.status_id')"
                                            :rules="ifValid('machines.status_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn v-if="machine.machine_id" color="error" @mouseup.left="$refs.delete_machines.openDialog()">{{ $t("lang.delete") }}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeMachineDialog()">{{ $t("lang.cancel") }}</v-btn>
                            <v-btn color="success" @click="saveMachines">{{ $t("lang.save") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_machines"
                :heading="$t('lang.delete_machine')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteMachines(machine.machine_id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openMachineForm" },
                { title: this.$t("lang.refresh"), action: "dbGetMachines", params: [true] },
            ],
            headers: [
                { text: this.$t("lang.machine_id"), sortable: false, width: "16%" },
                { text: this.$t("lang.line_id"), sortable: false, width: "16%" },
                { text: this.$t("lang.machine_name"), sortable: false, width: "16%" },
                { text: this.$t("lang.short_code"), sortable: false, width: "16%" },
                { text: this.$t("lang.category_id"), sortable: false, width: "16%" },
                { text: this.$t("lang.status_id"), sortable: false, width: "16%" },
            ],
            enableAddModal: true,
            enableEditModal: false,

            machine: {},
            filter: {
                search: "",
                status: "1",
            },
            machine_dialog: false,
            dbGetMachines: _.debounce(this.getMachines, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchMachines", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.machines) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.fetchMachines({
            body: parsedQuery,
        }).then((data) => {
            if (typeof data !== "undefined" && data.machines) {
                this.setQuery(parsedQuery, this.filter, this.default_filter);
                this.finishLoader();
                next();
            } else {
                next({ name: "dashboard", replace: true });
            }
        });
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.machines.machines_filter,
            page: (state) => state.machines.page,
            rules_machines: (state) => state.machines.rules_machines,
            machine_status_options: (state) => state.settings.machine_status_options,
            machines: (state) => state.machines.machines,
            production_lines: (state) => state.production.production_lines,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchMachines", "saveMachine", "deleteMachine"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openMachineForm(item = null) {
            if (item != null) {
                if (this.enableEditModal) {
                    if (this.$refs.form_machine) item ? this.$refs.form_machine.resetValidation() : this.$refs.form_machine.reset();

                    this.$nextTick(() => {
                        this.machine = item != null ? this.assignObj2(item, this.rules_machines) : {};
                        this.machine_dialog = true;
                    });
                } else {
                    this.$router.push({ name: "machine", params: { id: item.machine_id } });
                }
            } else {
                if (this.enableAddModal) {
                    if (this.$refs.form_machine) item ? this.$refs.form_machine.resetValidation() : this.$refs.form_machine.reset();
                    this.machine_dialog = true;
                } else {
                    this.$router.push({ name: "machine" });
                }
            }
        },
        saveMachines() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_machine")) {
                    let body = this.prepForm(this.machine, this.rules_machines);

                    this.saveMachine({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            if (this.enableEditModal) {
                                this.getMachines();
                                this.closeMachineDialog();
                            } else {
                                this.$router.push({ name: "machine", params: { id: data.machine_id } });
                            }
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteMachines(id = null) {
            this.deleteMachine({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getMachines();
                    this.closeMachineDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },

        closeMachineDialog() {
            this.machine_dialog = false;
            this.$refs.delete_machines.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        getMachines(pg_refresh = false) {
            this.startLoader();

            this.fetchMachines({
                body: JSON.parse(JSON.stringify(this.$route.query)),
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.machine_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                });
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "me/companies?module=people",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.companies;
                    }
                });
        },
        getProductionLines() {
            this.startLoader();
            this.$store
                .dispatch("fetchProduction", {
                    url: "production_lines",
                    method: "get",
                    stateProperty: "production_lines",
                    commit: true,
                    body: JSON.parse(JSON.stringify(this.$route.query)),
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.production_line_dialog = false;
                    this.$store.commit("toggleModalLoader", false);
                    this.$store.commit("validationOff");
                    this.finishLoader();
                });
        },
    },
    mounted() {
        this.getProductionLines();
    },
};
</script>
